module.exports = __webpack_public_path__ + "/login_ui/img/bh-5bb344c6a7405f10ae283daea9b0da67.svg";